"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProvider = void 0;
const providers_1 = require("../providers");
/**
 * Hook for accessing the current provider.
 *
 * @remarks
 *
 * Use this hook to access the current provider object
 * implementing starknet.js `ProviderInterface`.
 *
 * @example
 * This example shows how to access the current provider.
 * ```tsx
 * function Component() {
 *   const { provider } = useProvider()
 * }
 * ```
 */
function useProvider() {
    const { library: provider } = (0, providers_1.useStarknet)();
    return { provider };
}
exports.useProvider = useProvider;
//# sourceMappingURL=library.js.map